import { render, staticRenderFns } from "./IconFolderPlus.vue?vue&type=template&id=38e6c87d"
import script from "./IconFolderPlus.vue?vue&type=script&lang=js"
export * from "./IconFolderPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports